import { ComboboxModelModel, ComboboxSeparator } from '../../../combobox/combobox-model';
import { getFontFamily } from '../utils/email-styles';

export const FONT_FAMILY_ITEM = {
  modernSans: 'MODERN_SANS',
  bookSans: 'BOOK_SANS',
  organicSans: 'ORGANIC_SANS',
  geometricSans: 'GEOMETRIC_SANS',
  heavySans: 'HEAVY_SANS',
  roundedSans: 'ROUNDED_SANS',
  modernSerif: 'MODERN_SERIF',
  bookSerif: 'BOOK_SERIF',
  monospace: 'MONOSPACE',
} as const;

export const FONT_FAMILY_MODEL: ComboboxModelModel = [
  {
    value: FONT_FAMILY_ITEM.modernSans,
    item: (
      <span style={{ fontFamily: getFontFamily(FONT_FAMILY_ITEM.modernSans) }}>Modern Sans</span>
    ),
  },
  { item: ComboboxSeparator },
  {
    value: FONT_FAMILY_ITEM.bookSans,
    item: <span style={{ fontFamily: getFontFamily(FONT_FAMILY_ITEM.bookSans) }}>Book Sans</span>,
  },
  {
    value: FONT_FAMILY_ITEM.bookSerif,
    item: <span style={{ fontFamily: getFontFamily(FONT_FAMILY_ITEM.bookSerif) }}>Book Serif</span>,
  },
  {
    value: FONT_FAMILY_ITEM.geometricSans,
    item: (
      <span style={{ fontFamily: getFontFamily(FONT_FAMILY_ITEM.geometricSans) }}>
        Geometric Sans
      </span>
    ),
  },
  {
    value: FONT_FAMILY_ITEM.heavySans,
    item: <span style={{ fontFamily: getFontFamily(FONT_FAMILY_ITEM.heavySans) }}>Heavy Sans</span>,
  },
  {
    value: FONT_FAMILY_ITEM.modernSerif,
    item: (
      <span style={{ fontFamily: getFontFamily(FONT_FAMILY_ITEM.modernSerif) }}>Modern Serif</span>
    ),
  },
  {
    value: FONT_FAMILY_ITEM.monospace,
    item: <span style={{ fontFamily: getFontFamily(FONT_FAMILY_ITEM.monospace) }}>Monospace</span>,
  },
  {
    value: FONT_FAMILY_ITEM.organicSans,
    item: (
      <span style={{ fontFamily: getFontFamily(FONT_FAMILY_ITEM.organicSans) }}>Organic Sans</span>
    ),
  },
  {
    value: FONT_FAMILY_ITEM.roundedSans,
    item: (
      <span style={{ fontFamily: getFontFamily(FONT_FAMILY_ITEM.roundedSans) }}>Rounded Sans</span>
    ),
  },
] as const;

export type FontFamily = (typeof FONT_FAMILY_ITEM)[keyof typeof FONT_FAMILY_ITEM];
